define('models/wallet',['require','backbone'],function (require) {

    var Backbone = require('backbone');

    return Backbone.Model.extend({
        url: function () {
            // set the endpoint for restful api for articles
            return (App.Config.apiBase + 'reports/wallet-reports/');
        },

        defaults: function () {
            return {
                balance: 0,
                currency: ''
            };
        }
    });
});
